import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, CalendarClock, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const OPTIONS = [["instant", BellRing, "Instant emails", "One email for every payment, message and feedback"], ["daily", CalendarClock, "Daily roundup", "One email at 6pm Mountain time"]];

export const AlertSettings = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/admin/notification-settings").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const choose = async (mode) => {
    if (mode === s.mode) return;
    setBusy(mode);
    try { const { data } = await api.put("/admin/notification-settings", { mode }); setS(data); toast.success(mode === "daily" ? "Daily roundup on: alerts arrive at 6pm Mountain time" : "Instant alert emails on"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <div data-testid="alert-settings" className="mt-6 flex flex-wrap items-center gap-3 rounded-xl border border-slate-800 bg-slate-800/50 p-4">
      <div className="min-w-0 flex-1">
        <p className="text-xs uppercase tracking-wider text-slate-400">Alert emails to <span data-testid="alert-recipient" className="normal-case text-slate-200">{s.recipient}</span></p>
        <p className="mt-0.5 text-xs text-slate-500">Dispute alerts always arrive instantly.{s.mode === "daily" && <span data-testid="alert-pending"> {s.pending} waiting for tonight's roundup.</span>}</p>
      </div>
      <div className="flex gap-1 rounded-full bg-slate-900 p-1" role="radiogroup" data-testid="alert-mode-toggle">
        {OPTIONS.map(([k, Icon, label, hint]) => (
          <button key={k} role="radio" aria-checked={s.mode === k} title={hint} data-testid={`alert-mode-${k}`} onClick={() => choose(k)} disabled={!!busy}
            className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-bold transition-colors ${s.mode === k ? "bg-white text-slate-900" : "text-slate-300 hover:text-white"}`}>
            {busy === k ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Icon className="h-3.5 w-3.5" />}{label}
          </button>
        ))}
      </div>
    </div>
  );
};
